import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { usePreferences } from '../api/hooks';
import { ProjectContext } from './project-context';

const KEY = 'mantisbt.currentProject';

function stored(): number | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === null ? null : Number(v);
  } catch {
    return null;
  }
}

/**
 * Current project (legacy set_project.php + the project selector in the navbar). Remembered per
 * browser; the first visit uses the user's "default project" preference.
 */
export function ProjectProvider({ children }: { children: ReactNode }) {
  const prefs = usePreferences();
  const [chosen, setChosen] = useState<number | null>(stored);
  const projectId = chosen ?? prefs.data?.defaultProjectId ?? 0;
  const setProjectId = useCallback((id: number) => {
    setChosen(id);
    try {
      localStorage.setItem(KEY, String(id));
    } catch {
      /* private mode: session-only */
    }
  }, []);
  const value = useMemo(() => ({ projectId, setProjectId }), [projectId, setProjectId]);
  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}
